import { Outlet, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// project imports
import Customization from '../Customization';
import { SignOutAction } from 'store/action/authAction';
import { isTokenExpired } from '../../../../utils/Misc';

// ==============================|| MINIMAL LAYOUT ||============================== //

const MinimalLayout = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(SignOutAction());
        navigate('/auth/login');
    }, []);

    return (
        <>
            <Outlet />
            <Customization />
        </>
    );
};

export default MinimalLayout;
